import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { RuleSearchesResultsData } from "../../state/SearchManager/RuleSearchesResultsData";
import { RULE_SEARCHES_DEFAULT_LIMIT } from '../../state/SearchManager/RuleSearchesFormData';


const updateRuleSearchesResults: Reducer<RuleSearchesResultsData> = (state: RuleSearchesResultsData = new RuleSearchesResultsData(), action: Action<ActionType, RuleSearchesResultsData>) => {
  switch (action.type) {
    case ActionType.SEARCH_MANAGER_RULE_SEARCHES_RESULTS_FETCHED:
      let fetchedRuleSearchesList = action.data,
        showMore = false
      if (fetchedRuleSearchesList.length > RULE_SEARCHES_DEFAULT_LIMIT) {
        fetchedRuleSearchesList = fetchedRuleSearchesList.slice(0, RULE_SEARCHES_DEFAULT_LIMIT);
        showMore = true;
      }
      return { ...state, ruleSearchesList: fetchedRuleSearchesList, showMore };
    case ActionType.SEARCH_MANAGER_RULE_SEARCHES_RESULTS_UPDATED:
      let updatedRuleSearchesList = action.data,
        showMoreUpdated = false
      if (updatedRuleSearchesList.length > RULE_SEARCHES_DEFAULT_LIMIT) {
        updatedRuleSearchesList = updatedRuleSearchesList.slice(0, RULE_SEARCHES_DEFAULT_LIMIT);
        showMoreUpdated = true;
      }
      return { ...state, ruleSearchesList: [...state.ruleSearchesList, ...updatedRuleSearchesList], showMore: showMoreUpdated };
    case ActionType.SEARCH_MANAGER_RULE_SEARCHES_RESULTS_REFRESHED:
      let showMoreRefreshed = false
      if (action.data.length - 1 > state.ruleSearchesList.length) {
        showMoreRefreshed = true;
      }
      return { ...state, ruleSearchesList: action.data, showMoreRefreshed };
    case ActionType.SEARCH_MANAGER_RULE_SEARCHES_RESULTS_RESETED:
      return { ...state, ruleSearchesList: []}
    case ActionType.SEARCH_MANAGER_RULE_SEARCHES_RESULTS_LIST_ROW_DELETED:
      let newRuleSearchesList = state.ruleSearchesList.filter(item => item.id !== action.data.id);
      return { ...state, ruleSearchesList: newRuleSearchesList };
    default:
      return state;
  }
};

export default updateRuleSearchesResults;
